import { themedStyled } from 'common/styles/styletron.theme';

export const ActionTrigger = themedStyled('div', ({ $theme }) => ({
  cursor: 'pointer',
  padding: '8px 24px',
  borderRadius: '8px !important',
  background: 'white',
  border: `2px solid ${$theme.colors.primaryDefault}`,
  color: $theme.colors.primaryDefault,

  ':hover': {
    background: $theme.colors.primaryLightest,
    border: `2px solid ${$theme.colors.primaryDefault}`,
  },
  ':active': {
    background: $theme.colors.primaryLightest,
    border: `2px solid ${$theme.colors.primaryLight}`,
  },
  ...$theme.typography.body2Semibold,
}));

export const ActionItemButton = themedStyled('div', ({ $theme }) => ({
  cursor: 'pointer',
  background: $theme.colors.white,
  color: $theme.colors.primaryDefault,
  padding: '8px 24px',
  justifyContent: 'flex-start',
  ':hover': {
    background: $theme.colors.primaryLightest,
  },
  ':active': {
    background: $theme.colors.primaryLighter,
  },
  ...$theme.typography.body2Semibold,
}));

export const ScheduleCardHeaderRight = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
}));

export const ScheduleCardHeader = themedStyled('div', {
  display: 'flex',
  width: '100%',
});

export const ScheduleCardHeaderLeft = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  [$theme.mediaQuery.md]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
}));

export const OtherContainer = themedStyled('div', {
  display: 'flex',
  justifyContent: 'space-between',
});
